import React, { useEffect, useState } from "react";
import "./Languages.css";

export default function Languages() {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const checkTranslate = setInterval(() => {
      if (document.querySelector(".goog-te-combo")) {
        setIsReady(true);
        clearInterval(checkTranslate);
      }
    }, 500);
  }, []);

  const changeLanguage = (lang) => {
    const combo = document.querySelector(".goog-te-combo");
    if (combo) {
      combo.value = lang;
      combo.dispatchEvent(new Event("change"));
      localStorage.setItem("selectedLang", lang);
    }
  };

  useEffect(() => {
    const savedLang = localStorage.getItem("selectedLang");
    if (savedLang) {
      setTimeout(() => changeLanguage(savedLang), 1000);
    }
  }, [isReady]);

  const langs = [
    { code: "en", name: "English" },
    { code: "hi", name: "हिन्दी" },
    { code: "ta", name: "தமிழ்" },
    { code: "te", name: "తెలుగు" },
    { code: "kn", name: "ಕನ್ನಡ" },
    { code: "ml", name: "മലയാളം" },
  ];

  return (
    <div id="language-bar">
      <div id="google_translate_element" style={{ display: "none" }}></div>
      <div className="language-buttons">
        {langs.map((lang) => (
          <button
            key={lang.code}
            onClick={() => changeLanguage(lang.code)}
            disabled={!isReady}
            className={`lang-btn ${
              localStorage.getItem("selectedLang") === lang.code ? "active" : ""
            }`}
          >
            {lang.name}
          </button>
        ))}
      </div>
    </div>
  );
}
